module.exports = __webpack_public_path__ + "fonts/918cfd560907e3bdcc2b7df333489c6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/excess.svg
// module id = 2085
// module chunks = 0